enum FeatureType {
  BOOL = 'bool',
  NUMBER = 'number',
  TEXT = 'text',
  DATE_TIME = 'dateTime',
  LIST = 'list',
}

export default FeatureType;
